import React from "react"
import { Link } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image'
import cn from "classnames"
import Container from "./elements/Container"
import * as styles from "../scss/components/footer.module.scss"

import { solutions, support, news, editorial } from "../../config/navigation"

import LogoSVG from "./../assets/svg/logo-group-h.svg"
import PhoneSVG from "./../assets/svg/phone.svg"
import EmailSVG from "./../assets/svg/email-edit.svg"

const Footer = () => (
  <footer data-datocms-noindex>
    <div className={styles.linksFooterWrapper}>
      {/* Only render the logo once: it uses gradient IDs, which break if a hidden copy is on the page */}
      <div className={styles.logoContainer}>
        <div className="row pb-3 pt-lg-3 pb-lg-5">
          <div className={styles.logo}>
            <LogoSVG />
          </div>
        </div>
      </div>

      <div className="container">
        <div className={styles.linksFooterGrid}>
          <nav>
            <h6 className="mb-4">Solutions</h6>
            <ul className={styles.linksFooterList}>
              {solutions.map(link => (
                <li key={link.name} className={styles.linksFooterListItem}>
                  <Link to={link.to} title={link.name}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav>
            <h6 className="mb-4">Further Support</h6>
            <ul className={styles.linksFooterList}>
              {support.map(link => (
                <li key={link.name} className={styles.linksFooterListItem}>
                  <Link to={link.to} title={link.name}>
                    {link.name}
                  </Link>
                </li>
              ))}
              <li className={styles.linksFooterListItem}>
                <a
                  href="https://status.erudus.com/"
                  title="System Status"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  System Status
                </a>
              </li>
            </ul>
          </nav>

          <nav>
            <h6 className="mb-4">News</h6>
            <ul className={styles.linksFooterList}>
              {news.map(link => (
                <li key={link.name} className={styles.linksFooterListItem}>
                  <Link to={link.to} title={link.name}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav>
            <h6 className="mb-4">Editorial</h6>
            <ul className={styles.linksFooterList}>
              {editorial.map(link => (
                <li key={link.name} className={styles.linksFooterListItem}>
                  <Link to={link.to} title={link.name}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div className={styles.infoFooterWrapper}>
      <Container large>
        <div className={styles.contact}>
          <ul className={styles.infoList}>
            <li className={styles.infoListItem}>
              <PhoneSVG className={styles.iconPhone} />
              <a href="tel:03331218999">0333 121 89 99</a>
            </li>
            <li className={styles.infoListItem}>
              <EmailSVG className={styles.iconEmail} />
              <a href="mailto:support@erudus.com">support@erudus.com</a>
            </li>
            <li className={cn(styles.infoListItem, styles.hours)}>
              Monday - Friday, 09:00 - 17:00
            </li>
          </ul>
          <p className={styles.strapline}>United around food data.</p>
        </div>

        <div className={styles.copy}>
          <p className={styles.copyText}>
            © {new Date().getFullYear()} Erudus Limited
            <span className="d-none d-sm-none d-md-inline">&nbsp;•&nbsp;</span>
            <br className="d-xs-none d-sm-none" />
            Company no. 06315071 &nbsp;•&nbsp; VAT no. 917332138
            <br />
            Erudus Limited Panther House, Asama Court, Newcastle Business Park,
            Newcastle Upon Tyne, NE4 7YD, United Kingdom
          </p>

          <ul className={styles.copyLinks}>
            <li>
              <a href="https://registry.blockmarktech.com/certificates/9479ccf4-9749-49ea-839b-c7c46943f39d" title="Cyber Essentials Certified">
                <StaticImage src="./../assets/cyber-essentials-logo.avif" alt="Cyber Essentials Certified" layout="constrained" width="140" className="mr-4" />
              </a>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li className={styles.divider}>|</li>
            <li>
              <Link to="/terms-conditions">Terms & Conditions</Link>
            </li>
            <li className={styles.divider}>|</li>
            <li>
              <Link to="/cookies">Cookies</Link>
            </li>
          </ul>
        </div>
      </Container>
    </div>
  </footer>
)

export default Footer
